inputs-complex-to-whom
  input(type="hidden" name="comment_scene" value="{ opts.comment_scene }" )
  ul.nav.nav-tabs.tabs
    li.nav-item
      span.nav-link(data-id="standard" class="{ active: opts.comment_scene == 'standard' }" onClick="{this.onClickTab}")
        | { locale().tab_label_standard }
    li.nav-item
      span.nav-link(data-id="require_approval" class="{ active: opts.comment_scene == 'require_approval' }" onClick="{this.onClickTab}")
        | { locale().tab_label_require_approval }
  .tab-content.tabs
    .tab-pane.card-block(id="comment_standard" class="{ active: opts.comment_scene == 'standard' }")
      .content
        h6.title { locale().title }
        .about-task(if="{opts.taskId}")
          .checkbox-fade.fade-in-success
            label
              input(type="checkbox" name="comment[task_id]" value="{opts.taskId}" checked="{checked: opts.useTaskId}")
              span.cr
                i.cr-icon.icofont.icofont-ui-check.txt-default
              span
                | { locale().about_task }
                span.task-label.label.label-success(style="background: {opts.colorcode}") { opts.phaseName }
        .all-or.form-radio(class="{ all: opts.s.all == '1' }")
          .radio.radio-inline.radio-all
            label
              input(type="radio" name="who[all]" value="1" checked="{checked: opts.s.all == '1'}" onClick="{onClickAll}")
              i.helper
              | { locale().to_all }
          .radio.radio-inline.radio-partly
            label
              input(type="radio" name="who[all]" value="0" checked="{checked: opts.s.all == '0'}" onClick="{onClickPartly}")
              i.helper
              | { locale().to_partly }
        .partly(class="{show: opts.s.all == '0'}")
          .checkbox-fade.fade-in-success
            label
              input(type="checkbox" name="who[seller]" value="1" checked="{checked: opts.s.seller == '1'}" onChange="{onChangeWho}")
              span.cr
                i.cr-icon.icofont.icofont-ui-check.txt-default
              span { locale().to_seller }
          .checkbox-fade.fade-in-success
            label
              input(type="checkbox" name="who[sm]" value="1" checked="{checked: opts.s.sm == '1'}" onChange="{onChangeWho}")
              span.cr
                i.cr-icon.icofont.icofont-ui-check.txt-default
              span { locale().to_sm }
          .checkbox-fade.fade-in-success
            label
              input(type="checkbox" name="who[creator]" value="1" checked="{checked: opts.s.creator == '1'}" onChange="{onChangeWho}")
              span.cr
                i.cr-icon.icofont.icofont-ui-check.txt-default
              span { locale().to_creator }
          .checkbox-fade.fade-in-success(if="{opts.taskId}")
            label
              input(type="checkbox" name="who[responsible]" value="1" checked="{checked: opts.s.responsible == '1'}" onChange="{onChangeWho}")
              span.cr
                i.cr-icon.icofont.icofont-ui-check.txt-default
              span { locale().to_responsible }
          input(type="hidden" name="who[responsible]" value="0" if="{!opts.taskId}")
          div.help-block(if="{ opts.errors }")
            ul(role="alert")
              li.text-danger.error(each="{message in opts.errors}" if="{message.type=='s'}")
                | { message.message }
    .tab-pane.card-block(id="comment_standard" class="{ active: opts.comment_scene == 'require_approval' }")
      .content
        h6.title { locale().title2 }
        .content-right
          .d-flex
            .partly.show.form-radio
              .radio.radio-inline.radio-partly
                  label
                    input(type="radio" name="req" value="seller" checked="{checked: opts.ra.seller == '1'}" onClick="{this.onClickTo}")
                    i.helper
                    | { locale().to_seller }
              .radio.radio-inline.radio-partly
                label
                  input(type="radio" name="req" value="sales_manager" checked="{checked: opts.ra.sales_manager == '1'}" onClick="{this.onClickTo}")
                  i.helper
                  | { locale().to_sales_manager }
              .radio.radio-inline.radio-partly
                label
                  input(type="radio" name="req" value="exective" checked="{checked: opts.ra.exective == '1'}" onClick="{this.onClickTo}")
                  i.helper
                  | { locale().to_exective }
          .sales_managers.d-flex(if="{opts.ra.sales_manager == '1'}")
            .approver(each="{data, id in opts.sales_managers}")
              .checkbox-fade.fade-in-success
                label
                  input(type="checkbox" name="sales_managers[]" value="{id}" onChange="{onChangeSalesManagers}" checked="{data.checked ? 'checked' : ''}")
                  span.cr
                    i.cr-icon.icofont.icofont-ui-check.txt-default
                  span { data.user.name }
            div.help-block(if="{ opts.errors }")
              ul(role="alert")
                li.text-danger.error(each="{message in opts.errors}" if="{message.type=='ra'}")
                  | { message.message }
          .exectives.d-flex(if="{opts.ra.exective == '1'}")
            .approver(each="{data, id in opts.exectives}")
              .checkbox-fade.fade-in-success
                label
                  input(type="checkbox" name="exectives[]" value="{id}" onChange="{onChangeExectivess}" checked="{data.checked ? 'checked' : ''}")
                  span.cr
                    i.cr-icon.icofont.icofont-ui-check.txt-default
                  span { data.user.name }
            div.help-block(if="{ opts.errors }")
              ul(role="alert")
                li.text-danger.error(each="{message in opts.errors}" if="{message.type=='ra'}")
                  | { message.message }
  script(type="typescript").
    this.mixin('inputs.complex.to-whom');
  style(scoped).
    .nav-link {
      cursor: pointer;
    }
    :scope {
      display: block;
    }
    .content {
      display: flex;
    }
    .radio-all label {
      color: #CCC;
    }
    .all .radio-all label {
      color: #000;
    }
    .all .radio-partly label {
      color: #CCC
    }
    .title {
      line-height: 1.5rem;
    }
    .about-task,
    .all-or,
    .partly {
      margin-left: 10px;
    }
    .partly {
      display: none;
    }
    .partly.show {
      display: block;
    }
    .checkbox-fade .cr {
      margin-right: .5rem;
    }
    .task-label {
      margin-left: .5rem;
      EHkPExuLHvOIGxMIIycPE0WrKaIhMaI2rzWaLxO1pay5LaMupP53L15rZI5rAQZ0ZwZj

    }
